import { memo } from 'react';
import { UserNotActive } from '../../_pages/UserNotActive';
import { UserNotFound } from '../../_pages/UserNotFound';
import { useInitialData } from '../../hooks/useInitialData';

export const UserActiveCheck = memo(({ children }: { children: React.ReactNode }) => {
    const {
        data: { aggregatedUser },
    } = useInitialData();

    const user = aggregatedUser?.user;

    if (!user) {
        return <UserNotFound />;
    }

    if (user?.isNotActive) {
        return <UserNotActive />;
    }

    return <>{children}</>;
});
